import { render, staticRenderFns } from "./ConceptOverview.vue?vue&type=template&id=5396fd38&scoped=true&"
import script from "./ConceptOverview.vue?vue&type=script&lang=ts&"
export * from "./ConceptOverview.vue?vue&type=script&lang=ts&"
import style0 from "./ConceptOverview.vue?vue&type=style&index=0&id=5396fd38&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5396fd38",
  null
  
)

export default component.exports